import React from 'react';

import ReactDOM from 'react-dom';

import { initDatadogLogs } from 'utils/datadog';
import { initDatadogRum } from 'utils/datadog/rum';

import App from './app';
import * as serviceWorker from './serviceWorker';

// initialize Datadog SDKs before React renders to capture all errors and resources
initDatadogRum();
initDatadogLogs();

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
